import {Radio as BaseRadio, RadioProps} from '@esgi/ui-kit/control';
import {ElementStatus, useFormElementContext} from '@esgi/ui-kit/form';
import {ChangeEvent, useCallback} from 'react';
import {useForwardRef} from '@esgi/ui-kit/utils';

type DeprecatedProps = {
	/**
	 * @deprecated Do not use this property. Use ElementStatus.disabled on FormControl status instead.
	 * */
	disabled?: boolean;
}

type Props = Omit<RadioProps, 'checked' | 'onChange' | 'disabled'> & DeprecatedProps;

export function Radio(props: Props): JSX.Element {
	const {value, setValue, setRef, status} = useFormElementContext({string: true, number: true}, Radio);
	const onChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		const numeric = Number.parseInt(value);
		if (!isNaN(numeric)) {
			setValue(numeric);
		} else {
			setValue(e.target.value);
		}
	}, [setValue]);

	const ref = useForwardRef(setRef, props.innerRef);

	return <BaseRadio {...props}
	                  checked={value === props.value}
	                  innerRef={ref}
	                  onChange={onChange}
	                  aria-invalid={status === ElementStatus.invalid}
	                  disabled={status === ElementStatus.disabled || props.disabled}
	/>;
}


